import React from 'react';

const LinkSection = ({ sectionData, baseUrl }) => {
  // If no data is provided, don't render the section
  if (!sectionData || sectionData.length === 0) return null;

  // Helper to construct full URL for documents
  const getFullUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${baseUrl}/public/${path}`;
  };

  return (
    <section className="mt-0 mt-md-5 mb-5">
      <div className="container">
        {/* Container ID matches your original "ihecAccordion" */}
        <div className="accordion" id="ihecAccordion">
          {sectionData.map((item, index) => (
            <div className="accordion-item" key={item.id || index}>
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${item.id}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${item.id}`}
                >
                  {/* Displays heading from API, fallbacks to a default if empty string */}
                  {item.heading || "Guidelines"}
                </button>
              </h2>
              <div
                id={`collapse-${item.id}`}
                className="accordion-collapse collapse"
                data-bs-parent="#ihecAccordion"
              >
                <div className="accordion-body">
                  {item.pdfs && item.pdfs.map((pdf, pdfIndex) => (
                    <div className="mb-2" key={pdfIndex}>
                      <a
                        className="style4 text-decoration-underline"
                        href={getFullUrl(pdf.url)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* Exact icon class from your design: fa-file-pdf-o */}
                        <i className="fa fa-file-pdf-o text-danger me-2"></i>
                        
                        {/* Logic: If name contains ' – ', bold the part before it. Matches your design exactly. */}
                        {pdf.name && pdf.name.includes(' – ') ? (
                          <>
                            <strong>{pdf.name.split(' – ')[0]}</strong>
                            {` – ${pdf.name.split(' – ')[1]}`}
                          </>
                        ) : (
                          pdf.name
                        )}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LinkSection;